import { Action } from '@ngrx/store';
import {
    AuctionStatus,
    GetFeaturedAuctions200Response,
} from '@viewbid/ts-angular-client';

export interface GenericActionPayload {
    data: string;
}

export enum AuctionsPageUIActions {
    LoadAuctionsAction = '[UI] Load Auctions',
}

interface LoadAuctionsActionProps {
    page: number;
    size: number;
    filter: string[];
}

export class LoadAuctionsAction implements Action {
    readonly type: AuctionsPageUIActions =
        AuctionsPageUIActions.LoadAuctionsAction;

    public props: LoadAuctionsActionProps;

    constructor(props: LoadAuctionsActionProps) {
        this.props = props;
    }
}

export enum AuctionsPageServiceActions {
    LoadAuctionsFailedAction = '[Auctions Service] Loading Auctions Failed',
    AuctionsLoadedAction = '[Auctions Service] Auctions Loaded',
    UpdateAuctionStatusAction = '[Auctions Service] Update Auction Status',
}

export interface AuctionsLoadedActionProps {
    result: GetFeaturedAuctions200Response;
}

export interface UpdateAuctionActionProps {
    auctionId: string;
    status: AuctionStatus;
}

export class AuctionsLoadedAction implements Action {
    readonly type: AuctionsPageServiceActions =
        AuctionsPageServiceActions.AuctionsLoadedAction;

    public props: AuctionsLoadedActionProps;

    constructor(props: AuctionsLoadedActionProps) {
        this.props = props;
    }
}

export class LoadAuctionsFailedAction implements Action {
    readonly type: AuctionsPageServiceActions =
        AuctionsPageServiceActions.LoadAuctionsFailedAction;
}

export class UpdateAuctionStatusAction implements Action {
    readonly type: AuctionsPageServiceActions =
        AuctionsPageServiceActions.UpdateAuctionStatusAction;

    public props: UpdateAuctionActionProps;

    constructor(props: UpdateAuctionActionProps) {
        this.props = props;
    }
}
